let Constants = {
    API_ENDPOINT: "https://fette-06-2019.contestwinning.it",
    API_TOKEN: "ae0ea2ef-6d74-11e9-93e6-0242ac10ee0c",
    PROMO_CODE: "promofette2019",
    CH_PROMO: "CH_302_MLB_WEB_FETTE19_BKR_CRS_20190604_20190831",
    CLOSING_STEP_1_DATE: "30/08/2019 19:00"
}

export default Constants;
